import React from "react";
import { Link } from "react-router-dom";
import { CircleHelp } from "lucide-react";
import { ToastContainer } from "react-toastify";
import { Notification } from "../Notifications/Notification";
import LanguageSelector from "../LanguageSelector/LanguageSelector";
import ProfileMenu from "./ProfileMenu";

export default function HeaderActions({
  t,
  language,
  changeLanguage,
  user,
  openMenu,
  setOpenMenu,
  closeMobileMenu,
  handleLinkClick,
  handleLogout,
  googleLogin,
}) {
  return (
    <>
      <div className="header-actions">
        <div className="menu-icon-item menu-notification-item">
          <Notification
            isOpen={openMenu === "notifications"}
            setOpenMenu={setOpenMenu}
            closeProfileMenu={() =>
              setOpenMenu((prev) =>
                prev === "profile" || prev === "mobileProfile" ? null : prev,
              )
            }
            closeMobileMenu={closeMobileMenu}
          />
        </div>

        <div className="menu-icon-item menu-help-item">
          <Link
            to="/help"
            className="help-icon-link"
            onClick={handleLinkClick}
            aria-label="Help Center"
          >
            <CircleHelp className="header-icon help-header-icon" />
          </Link>
        </div>

        <div className="language-selector-item">
          <LanguageSelector
            language={language}
            onLanguageChange={changeLanguage}
            openMenu={openMenu}
            setOpenMenu={setOpenMenu}
          />
        </div>

        <div className="menu-signin-item">
          {user ? (
            <>
              <div className="desktop-profile-menu">
                <ProfileMenu
                  user={user}
                  t={t}
                  openMenu={openMenu}
                  setOpenMenu={setOpenMenu}
                  handleLogout={handleLogout}
                  handleLinkClick={handleLinkClick}
                />
              </div>

              <button
                type="button"
                className="icon-circle-btn mobile-user-trigger"
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenMenu((prev) =>
                    prev === "mobileProfile" ? null : "mobileProfile",
                  );
                }}
                aria-label="Open user menu"
                aria-expanded={openMenu === "mobileProfile"}
              >
                <img
                  src={user.imageUrl}
                  alt={user.name || t("user")}
                  className="header-user-img mobile-user-img"
                  width="40"
                  height="40"
                  loading="lazy"
                  decoding="async"
                />
              </button>
            </>
          ) : (
            <button type="button" onClick={googleLogin} className="signin-btn">
              {t("signIn")}
            </button>
          )}
        </div>

        {user && openMenu === "mobileProfile" && (
          <ProfileMenu
            user={user}
            t={t}
            openMenu={openMenu}
            setOpenMenu={setOpenMenu}
            handleLogout={handleLogout}
            handleLinkClick={handleLinkClick}
          />
        )}
      </div>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
      />
    </>
  );
}
